// roofa-font.js

document.addEventListener('DOMContentLoaded', function() {
  const targetString = 'RooFa';
  const targetColorHex = '#2E7D32'; // RooFaに適用したい色
  const standardClassName = 'custom-roofa-style'; // 通常適用のCSSクラス
  const alternativeClassName = 'custom-roofa-style-alternative'; // 例外適用のCSSクラス
  const regex = new RegExp(targetString, 'g');
  const excludedTags = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'CODE', 'PRE', 'TITLE'];
  const processedFlag = 'data-roofa-processed'; // 処理済み要素に付与する属性

  let isProcessing = false; // MutationObserverの処理中フラグ

  // --- ヘルパー関数 (変更なし) ---
  function hexToRgb(hex) {
    if (!hex || typeof hex !== 'string') return null;
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    if (hex.length !== 6) return null;
    const num = parseInt(hex, 16);
    if (isNaN(num)) return null;
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  }

  function rgbStringToHex(rgbString) {
    if (!rgbString || typeof rgbString !== 'string') return null;
    const match = rgbString.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d\.]+)?\)$/);
    if (!match) return null;
    return "#" + ((1 << 24) + (parseInt(match[1]) << 16) + (parseInt(match[2]) << 8) + parseInt(match[3])).toString(16).slice(1).toUpperCase();
  }

  function areColorsSimilar(color1Hex, color2Hex, threshold = 60) { // 閾値を調整
    const rgb1 = hexToRgb(color1Hex);
    const rgb2 = hexToRgb(color2Hex);
    if (!rgb1 || !rgb2) return false;
    const diff = Math.abs(rgb1.r - rgb2.r) + Math.abs(rgb1.g - rgb2.g) + Math.abs(rgb1.b - rgb2.b);
    return diff <= threshold;
  }

  function getEffectiveBackgroundColor(element) {
    let currentElement = element;
    while (currentElement) {
      const style = window.getComputedStyle(currentElement);
      const bgColor = style.backgroundColor;
      if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
        return rgbStringToHex(bgColor);
      }
      if (currentElement === document.body || !currentElement.parentElement) {
        const bodyStyle = window.getComputedStyle(document.body);
        const bodyBgColor = bodyStyle.backgroundColor;
        return (bodyBgColor && bodyBgColor !== 'rgba(0, 0, 0, 0)' && bodyBgColor !== 'transparent') ? rgbStringToHex(bodyBgColor) : '#FFFFFF';
      }
      currentElement = currentElement.parentElement;
    }
    return '#FFFFFF';
  }

  function hasConflictingTextShadow(element, conflictColorHex, threshold = 40) { // 閾値を調整
    let currentElement = element;
    while (currentElement) {
      const style = window.getComputedStyle(currentElement);
      const textShadow = style.textShadow;
      if (textShadow && textShadow !== 'none') {
        const shadows = textShadow.split(/,\s*(?![^()]*\))/);
        for (const shadow of shadows) {
          const colorMatch = shadow.match(/(#[0-9a-fA-F]{3,6}|rgb[a]?\([^)]+\))/);
          if (colorMatch && colorMatch[0]) {
            let shadowColorHex = colorMatch[0].startsWith('rgb') ? rgbStringToHex(colorMatch[0]) : colorMatch[0];
            if (shadowColorHex && areColorsSimilar(shadowColorHex, conflictColorHex, threshold)) return true;
          }
        }
      }
      if (currentElement === document.body || !currentElement.parentElement) break;
      currentElement = currentElement.parentElement;
    }
    return false;
  }

  function createStyledSpan(text, className) {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    span.setAttribute(processedFlag, 'true'); // 処理済みフラグをspan自体に付与
    return span;
  }

  // --- メインの置換処理関数 ---
  function replaceTextInNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const parentEl = node.parentNode;
      // 親がいない、または親が除外タグ(大文字比較)、または親が処理済みならスキップ
      if (!parentEl || excludedTags.includes(parentEl.tagName.toUpperCase()) || parentEl.hasAttribute(processedFlag)) {
        return;
      }

      const nodeValue = node.nodeValue;
      if (nodeValue.includes(targetString)) {
        let chosenClassName = standardClassName;
        const bgColor = getEffectiveBackgroundColor(parentEl);
        const shadowConflict = hasConflictingTextShadow(parentEl, targetColorHex);

        if ((bgColor && areColorsSimilar(bgColor, targetColorHex)) || shadowConflict) {
          chosenClassName = alternativeClassName;
        }

        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        regex.lastIndex = 0;

        while ((match = regex.exec(nodeValue)) !== null) {
          if (match.index > lastIndex) {
            fragment.appendChild(document.createTextNode(nodeValue.substring(lastIndex, match.index)));
          }
          fragment.appendChild(createStyledSpan(match[0], chosenClassName));
          lastIndex = regex.lastIndex;
        }

        if (lastIndex < nodeValue.length) {
          fragment.appendChild(document.createTextNode(nodeValue.substring(lastIndex)));
        }

        if (fragment.childNodes.length > 0) {
            parentEl.replaceChild(fragment, node);
        }
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // 除外タグ(大文字比較) or 既に処理された要素はスキップ
      if (excludedTags.includes(node.tagName.toUpperCase()) || node.hasAttribute(processedFlag)) {
        return;
      }
      // 子ノードに対して再帰的に処理
      Array.from(node.childNodes).forEach(child => replaceTextInNode(child));
    }
  }

  // --- 処理の実行と監視 ---
  function processDOMChanges(nodes) {
    if (isProcessing) return;
    isProcessing = true;
    if (observer) observer.disconnect(); // 監視を一時停止

    for (const node of nodes) {
      // document.body 内のノードを処理対象とする
      if (document.body.contains(node) || node === document.body) {
          replaceTextInNode(node);
      }
    }

    // 監視対象を document.body に限定して再開
    if (observer) observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'disabled'] });
    isProcessing = false;
  }

  // 初期読み込み時の処理 (対象は document.body)
  setTimeout(() => {

    processDOMChanges([document.body]);

  }, 200);

  // MutationObserverの準備 (監視対象は document.body)
  const observer = new MutationObserver(mutationsList => {
    if (isProcessing) return;

    const nodesToReProcess = new Set();
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
                // body 内に追加されたノードのみを対象とする
                if (document.body.contains(node)) {
                    nodesToReProcess.add(node);
                }
            });
        } else if (mutation.type === 'attributes') {
            // body 内の要素の属性変更のみを対象とする
            if (document.body.contains(mutation.target)) {
                nodesToReProcess.add(mutation.target);
            }
        }
    }

    if (nodesToReProcess.size > 0) {
        setTimeout(() => processDOMChanges(Array.from(nodesToReProcess)), 150);
    }
  });

  // 監視開始は processDOMChanges 内で行われる
});